import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';

type CommonProps = {
  href: string;
  isJsonSchema?: boolean;
  children: ReactNode;
};

type RequestLinkProps = CommonProps &
  Omit<LinkProps, 'to'> &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

const RequestLink = ({
  href,
  isJsonSchema,
  children,
  ...props
}: RequestLinkProps) => {
  if (isJsonSchema) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} {...props}>
      {children}
    </Link>
  );
};

export default RequestLink;
